/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ActionPlanDetailsAliases {
  ACTION_ADD_HISTORY = 'action-add-history',
  ACTION_FINISH = 'action-finish',
  ACTION_PRINT = 'action-print',
  ATTACHMENTS_LIST = 'attachments-list',
  AVATAR_0 = 'avatar-0',
  CARD_0 = 'card-0',
  CARD_HISTORY = 'card-history',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  DECK_ACTIONS = 'deck-actions',
  DECK_HISTORIES = 'deck-histories',
  FETCH_ACTION = 'fetch-action',
  FETCH_ACTION_PLAN = 'fetch-action-plan',
  FETCH_ACTION_PLAN_HISTORY = 'fetch-action-plan-history',
  FETCH_ACTIONS = 'fetch-actions',
  FETCH_ATTACHMENT_LIST = 'fetch-attachment-list',
  FETCH_HISTORIES = 'fetch-histories',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_7 = 'field-7',
  FIELD_8 = 'field-8',
  FIELD_10 = 'field-10',
  FIELD_11 = 'field-11',
  FIELD_ACTION = 'field-action',
  FIELD_ATTACHMENT_LIST = 'field-attachment-list',
  FIELD_CANCEL_REASON = 'field-cancel-reason',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_EFFECTIVITY = 'field-effectivity',
  FIELD_PLAN = 'field-plan',
  FIELD_REFUSAL_REASON = 'field-refusal-reason',
  FIELD_STATUS = 'field-status',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_1 = 'form-1',
  FORM_ACTION_PLAN = 'form-action-plan',
  FORM_HISTORY = 'form-history',
  FORM_NEW_HISTORY = 'form-new-history',
  HPMS_CUSTOM_CARD_0 = 'hpms-custom-card-0',
  LAYOUT_0 = 'layout-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_ATTACHMENT = 'mapper-attachment',
  MODAL_ACTION = 'modal-action',
  MODAL_HISTORY = 'modal-history',
  MODAL_NEW_HISTORY = 'modal-new-history',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_ATIONS = 'panel-ations',
  PANEL_ATTACHMENTS = 'panel-attachments',
  PANEL_MODAL = 'panel-modal',
  PANEL_MODAL_ADD_HISTORY = 'panel-modal-add-history',
  PANEL_MODAL_HISTORY = 'panel-modal-history',
  TAB_ACTIONS = 'tab-actions',
  TAB_ATTACHMENTS = 'tab-attachments',
  TAB_CONTROL = 'tab-control',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_9 = 'text-9',
  TEXT_10 = 'text-10',
  TEXT_ACTION = 'text-action',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_DESCRIPTION = 'text-description',
}
export { ActionPlanDetailsAliases };
